import Vue from 'vue';
import Debug from './Debug.vue';

export { Debug };

/**
 * 独立挂载到 document.body，避免被主布局 overflow / transform 裁切。
 * Vue 2 的 $mount(el) 会替换 el 节点，故先 $mount() 再 append $el，以保留 fixed 容器定位。
 */
export function initializeDebug() {
  const debugContainer = document.createElement('div');
  debugContainer.style.position = 'fixed';
  debugContainer.style.top = '0';
  debugContainer.style.right = '0';
  debugContainer.style.zIndex = '9999';
  document.body.appendChild(debugContainer);

  const instance = new Vue({
    render: (h) => h(Debug),
  }).$mount();
  debugContainer.appendChild(instance.$el);
}
